// extracted by mini-css-extract-plugin
export default {"paymentSection":"k7-z"};